import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Button,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import { deleteItem, deleteReader, openBarrier } from '../../api/axios';
import { hasPermission } from '../../context/AuthFunc';
import { PERMISSIONS } from '../../constants/const';

const DataTable = ({ initialData, columns, entityName, h2 }) => {
  const { t } = useTranslation('global');
  const [data, setData] = useState(initialData);

  const navigate = useNavigate();

  const handleEdit = (id) => {
    navigate(`/${entityName}/edit/${id}`);
  };

  const handleDelete = async (id) => {
    if (window.confirm(t('table.areYouSure'))) {
      const params = new URLSearchParams();
      params.append("id", id);

      let result;
      if (entityName === "readers") {
        result = await deleteReader(params);
      } else if (entityName === "item") {
        result = await deleteItem(params);
      }
      console.log(result);
      if (result?.success) {
        // Filtriraj stavke kako bi uklonio obrisanu stavku
        setData((prevData) => prevData.filter((item) => item.id !== id));
        console.log(t('table.deletedSuccessfully'));
      } else {
        console.error(t('table.deleteFailed'));
      }
    }
  };

  const handleOpen = async (id) => {
    const reader = data.find((item) => item.id === id);
    if (reader) {
      const params = new URLSearchParams();
      params.append("command","OPEN_BARRIER");
      params.append("serial_number",reader.serial_num)
      try {
        await openBarrier(params);
      } catch (error) {
        console.error('Error opening barrier:', error);
      }
    } else {
      alert(t('table.readerNotFound'));
    }
  };
  


  return (
    <Box fullWidth>
      <Typography variant="h4" gutterBottom>
        {h2}
      </Typography>
      <TableContainer component={Paper} sx={{ backgroundColor: "transparent" }} fullWidth>
        <Table sx={{ backgroundColor: "transparent" }} fullWidth>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.accessor} variant="head">
                  {column.Header}
                </TableCell>
              ))}
              {!(entityName==="templateGroupEvents") && (
              <TableCell variant="head">{t("table.actions")}</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
  {data.map((item) => (
    <TableRow key={item.id}>
      {columns.map((column) => (
        <TableCell key={column.accessor}>
          {column.accessor === "active" 
            ? item[column.accessor] === "1" 
              ? t("table.yes") 
              : t("table.no")
            : item[column.accessor]}
        </TableCell>
      ))}
      {!(entityName==="templateGroupEvents") &&(
      <TableCell>
        <IconButton
          color="inherit"
          onClick={() => handleEdit(item.id)}
          aria-label="edit"
        >
          <EditIcon />
        </IconButton>
        {hasPermission(PERMISSIONS.DELETE_ITEM) && (<IconButton
          color="inherit"
          onClick={() => handleDelete(item.id)}
          aria-label="delete"
        >
          <DeleteIcon />
        </IconButton>)}
        {(entityName==="readers") && (
          <IconButton
          color="inherit"
          onClick={() => handleOpen(item.id)}
          aria-label="open"
        >
          <LockOpenIcon />
        </IconButton>
        )}
      </TableCell>
      )}
    </TableRow>
  ))}
</TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DataTable;
